import React, { useState, useEffect } from "react";
import marubitLogo from "../../assets/images/marubit_logo.png";
import MobileSidebar from "./MobileSidebar";
import { useNavStore } from "../../store/navStore";
import { Link, useLocation } from "react-router-dom";
import { useAuthStore } from "../../store/authStore";

export default function MobileHeader() {
  const { isLoggedIn, clearAuth } = useAuthStore()
  
  useEffect(() => {
    const checkToken = () => {
      const token = localStorage.getItem('access_token')
      if (!token) {
        if (isLoggedIn) clearAuth()
        return
      }
      try {
        const payload = JSON.parse(atob(token.split('.')[1]))
        if (Date.now() > payload.exp * 1000) clearAuth()
      } catch {
        clearAuth()
      }
    }
    checkToken()
    const interval = setInterval(checkToken, 10000)
    return () => clearInterval(interval)
  }, [isLoggedIn, clearAuth])
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const location = useLocation();
  const { navItems } = useNavStore();
  const [openMenu, setOpenMenu] = useState<string | null>(null);

  useEffect(() => {
    const matched = navItems.find(item =>
      item.children?.some(c => c.href && location.pathname.startsWith(c.href))
    );
    if (matched) setOpenMenu(matched.label);
  }, [navItems, location.pathname]);

  return (
    <>
      <header className="flex items-center justify-between px-4 py-3 bg-white shadow-[0_2px_8px_rgba(0,0,0,0.07)] sticky top-0 z-[100]">

        {/* 햄버거 버튼 */}
        <button
          onClick={() => setSidebarOpen(true)}
          className="bg-transparent border-none cursor-pointer p-1 text-[#333]"
          aria-label="메뉴 열기"
        >
          <svg viewBox="0 0 24 24" width={26} height={26} fill="none" stroke="currentColor" strokeWidth={2.2}>
            <line x1="3" y1="6" x2="21" y2="6" />
            <line x1="3" y1="12" x2="21" y2="12" />
            <line x1="3" y1="18" x2="21" y2="18" />
          </svg>
        </button>

        {/* 로고 중앙 */}
        <Link to="/" className="absolute left-1/2 -translate-x-1/2 no-underline">
          <img src={marubitLogo} alt="서천 커뮤니티센터 마루빛" className="h-12 w-auto" />
        </Link>

        {/* 우측 균형용 */}
        <div className="w-[34px]" />
      </header>

      <MobileSidebar
        open={sidebarOpen}
        onClose={() => setSidebarOpen(false)}
        openMenu={openMenu}
        setOpenMenu={setOpenMenu}
        navItems={navItems}
      />
    </>
  );
}